var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "betslip-footer-wrapper" },
    [
      _vm.config.futureBets
        ? _c(
            "div",
            {
              staticClass: "future-bets",
              class: { disabled: _vm.bettingLocked },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeDropdown,
                      expression: "closeDropdown",
                    },
                  ],
                  staticClass: "footer-dropdown",
                  class: { expanded: _vm.expanded },
                  on: { click: _vm.expandDropdown },
                },
                [
                  _c("label", [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("translate")("general_future_bet")) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.futureBets > _vm.maxFutureBets
                            ? 1
                            : _vm.futureBets
                        ) +
                        " "
                    ),
                  ]),
                  _c("i", { staticClass: "icon", class: _vm.dropdownIcon }),
                  _c("Scrollable", [
                    _vm.expanded && !_vm.bettingLocked && !_vm.isMob
                      ? _c(
                          "div",
                          { staticClass: "dropdown-list" },
                          _vm._l(_vm.maxFutureBets, function (option, key) {
                            return _c(
                              "div",
                              {
                                key: key,
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.changeFutureBets(option)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(option) + " ")]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.config.totalStake
        ? _c(
            "div",
            {
              staticClass: "total-stake",
              class: { disabled: _vm.bettingLocked },
              on: { click: _vm.setTotalPaymentFocus },
            },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("translate")("general_total_stake")) + " "
                ),
              ]),
              _c("input", {
                ref: "totalPayment",
                staticClass: "value no-spinner",
                attrs: {
                  "data-layout": "numeric",
                  inputmode: "numeric",
                  type: "number",
                },
                domProps: { value: _vm.totalPayment.toFixed(2) },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changeTotalStake.apply(null, arguments)
                  },
                  blur: _vm.changeTotalStake,
                },
              }),
              _c("i", {
                staticClass: "icon icon-backspace-a",
                on: {
                  click: function ($event) {
                    return _vm.clear()
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      _c("BetslipTaxInfo", { attrs: { taxDisabled: _vm.taxDisabled } }),
      _c("div", { staticClass: "payin-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "button empty-betslip",
            class: { disabled: !_vm.ticket.bets.length || _vm.bettingLocked },
            attrs: { disabled: !_vm.ticket.bets.length || _vm.bettingLocked },
            on: { click: _vm.removeBets },
          },
          [_c("i", { staticClass: "icon icon-trash" })]
        ),
        !_vm.player.loggedIn
          ? _c(
              "button",
              {
                staticClass: "button important login-button",
                on: {
                  click: function ($event) {
                    return _vm.login()
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm._f("translate")("general_sign_in")) + " "
                ),
              ]
            )
          : _vm._e(),
        _vm.player.loggedIn
          ? _c(
              "button",
              {
                staticClass: "button important payin-button",
                class: { disabled: _vm.isPayinDisabled },
                attrs: { disabled: _vm.isPayinDisabled },
                on: {
                  click: function ($event) {
                    return _vm.payinTicket()
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm._f("translate")("general_pay_in")) + " "
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c(
        "stake-fade-transition",
        [
          _vm.showStakeBox && !_vm.bettingLocked
            ? _c("StakeBox", {
                attrs: { predefinedStakes: _vm.predefinedStakes },
                on: { close: _vm.toggleStakeBox },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }